import { cardsData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '新番': 'bg-accent-100 text-accent-700',
  '完结': 'bg-primary-100 text-primary-700',
  '热更': 'bg-accent-100 text-accent-700',
  '推荐': 'bg-accent-100 text-accent-700',
  '经典': 'bg-secondary-100 text-secondary-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-book-open-line"></i>
            <span>作品推荐</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            编辑精选 · 本周不容错过的好漫
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            编辑团队精心挑选，每周更新推荐书单，帮你发现下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={idx}
              className={`group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 ${
                idx >= 6 ? 'lg:hidden xl:block' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`女神漫画 - ${item.title}`}
                  className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ aspectRatio: '3/4' }}
                />
                <div className="absolute top-3 left-3">
                  <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="text-xs text-primary-500 font-medium mb-1">{item.category}</div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1.5 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}